import script from "./Orders.vue?vue&type=script&setup=true&lang=js"
export * from "./Orders.vue?vue&type=script&setup=true&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=49b4a54a&setup=true&lang=css"

const __exports__ = script;

export default __exports__